<div class="vl"></div>
<ion-buttons class="close" slot="primary">
  <ion-button class="btn-round" (click)="dismiss()">
    <ion-icon slot="icon-only" name="close" size="small"></ion-icon>
  </ion-button>
</ion-buttons>
<div class="content">
  <div class="head">
    <img class="green" src="assets/img/icon-documents.svg" />
    <img class="white" src="assets/img/icon-documents-white.svg" />
    <span>{{'__VIDEOCHAT_DOCUMENTS_HEADER__' | translate}}</span>
  </div>

  <div class="contents">

    <div class="docs-container">
      <div class="docs-box">
        <div class="doc-name">
          <img src="assets/img/icon-documents.svg" /><span>Document 1</span>

        </div>
        <div class="click-to-open">
          <img src="assets/img/icon-click-to-open.svg" /><span>{{'__VIDEOCHAT_DOCUMENTS_CLICK_TO_OPEN__' | translate}}</span>
        </div>
      </div>
      <div class="docs-box">
        <div class="doc-name">
          <img src="assets/img/icon-documents.svg" /><span>Document 1</span>

        </div>
        <div class="click-to-open">
          <img src="assets/img/icon-click-to-open.svg" /><span>{{'__VIDEOCHAT_DOCUMENTS_CLICK_TO_OPEN__' | translate}}</span>
        </div>
      </div>
      <div class="docs-box">
        <div class="doc-name">
          <img src="assets/img/icon-documents.svg" /><span>Document 1</span>

        </div>
        <div class="click-to-open">
          <img src="assets/img/icon-click-to-open.svg" /><span>{{'__VIDEOCHAT_DOCUMENTS_CLICK_TO_OPEN__' | translate}}</span>
        </div>
      </div>
      <div class="docs-box">
        <div class="doc-name">
          <img src="assets/img/icon-documents.svg" /><span>Document 1</span>

        </div>
        <div class="click-to-open">
          <img src="assets/img/icon-click-to-open.svg" /><span>{{'__VIDEOCHAT_DOCUMENTS_CLICK_TO_OPEN__' | translate}}</span>
        </div>
      </div>
      <div class="docs-box">
        <div class="doc-name">
          <img src="assets/img/icon-documents.svg" /><span>Document 1</span>

        </div>
        <div class="click-to-open">
          <img src="assets/img/icon-click-to-open.svg" /><span>{{'__VIDEOCHAT_DOCUMENTS_CLICK_TO_OPEN__' | translate}}</span>
        </div>
      </div>
      <div class="docs-box">
        <div class="doc-name">
          <img src="assets/img/icon-documents.svg" /><span>Document 1</span>

        </div>
        <div class="click-to-open">
          <img src="assets/img/icon-click-to-open.svg" /><span>{{'__VIDEOCHAT_DOCUMENTS_CLICK_TO_OPEN__' | translate}}</span>
        </div>
      </div>


    </div>


    <div class="add-btn">
      <button class="btn-round "><img src="assets/img/icon-add-green.svg"></button>
    </div>
  </div>
</div>